import React from 'react'
import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Text,
    useColorModeValue,
} from '@chakra-ui/react'
import RichContent from '../../uielements/RichContent/richContent'
import PhotoSwipeGallery from '../../components/Gallery'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import SectionHeader from '../../components/SectionHeader'
import Attachments from './attachments'

const AccordionBody = styled.div`
    img {
        max-width: 50%;
        display: block;
        margin: 6px auto;
        border-radius: 4px;
    }
`

const PageAccordion = ({ page }) => {
    const bg = useColorModeValue('gray.50', 'gray.600')
    const { i18n, t } = useTranslation()

    const accordion = page?.accordion || page?.pageBlocks || null

    const readMoreTitle = page?.pageBlockTitle || page?.eduPageBlockTitle || t('titles.read_more')
    const pageBlockSubtitle = page?.pageBlockSubtitle || page?.eduPageBlockSubtitle || t('subtitles.read_more')

    return (
        accordion && (
            <Box py={4} pos={'relative'}>
                <SectionHeader title={readMoreTitle} subtitle={pageBlockSubtitle} />
                <Box mt={6} px={[0, 0, 12]} position={'relative'}>
                    <Accordion allowToggle>
                        {accordion?.map((item) => (
                            <AccordionItem key={item.title} borderRadius={8} my={4}>
                                <AccordionButton borderRadius={8} bgColor={bg} border={'2px solid'}>
                                    <Box as="span" flex="1" textAlign="left">
                                        <Text p={3} fontSize={'1.2rem'}>
                                            {item.title}
                                        </Text>
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                                <AccordionPanel>
                                    <AccordionBody>
                                        <RichContent body={item.body} locale={i18n.language} />
                                    </AccordionBody>
                                    <PhotoSwipeGallery images={item?.gallery} />
                                    <Attachments attachments={item?.attachments} />
                                </AccordionPanel>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Box>
            </Box>
        )
    )
}

export default PageAccordion
